import { ReactElement, ReactNode, Fragment } from 'react'
import { ListItemsGroupName } from 'components/lists'
import { ListContainer, ListItemWrapper, GroupNameWrapper } from './List.styled'

type ListProps = {
  dataTest?: string
}

type ListItemWithGroupName = ReactElement<{ groupName?: string }>

function getGroupName(children: ReactNode): string | undefined {
  if (!children || typeof children !== 'object') return

  const listItem = children as ListItemWithGroupName
  return listItem.props.groupName
}

const List: React.FC<ListProps> = ({ children, dataTest }) => {
  const items = Array.isArray(children) ? children : [children]
  let previousGroupName: string | undefined

  return (
    <ListContainer data-test={dataTest}>
      {items.map((ListItemComponent, index) => {
        const currentGroupName = getGroupName(ListItemComponent)
        const needShowGroupName = currentGroupName && currentGroupName !== previousGroupName
        previousGroupName = currentGroupName

        return (
          <Fragment key={index}>
            {needShowGroupName && (
              <GroupNameWrapper>
                <ListItemsGroupName groupName={currentGroupName} />
              </GroupNameWrapper>
            )}
            <ListItemWrapper>{ListItemComponent}</ListItemWrapper>
          </Fragment>
        )
      })}
    </ListContainer>
  )
}

export default List
